module.exports = __webpack_public_path__ + "img/horizontal_3_7_8004.2e403ada.png";